import React from 'react'
import PropTypes from 'prop-types'
import { getPageScrollLength , fakeDelay , removeCharFromLhsAndTabs, smoothScrollToTarget } from '../../util'
import { TabItem, TabWrapper, TabTitle, TabMainWrapper } from './style'
import { TourGuide } from '../../components'
import { useGlobalStore } from '../../store'

const Tabs = ({ data, obj, isFirstTab }) => {
  const tabId = `id_${removeCharFromLhsAndTabs(obj.ParentTitle)}_${obj.InsightsElementId.replaceAll('-', '')}` // #id_Profile_6b6445e876534af4b839e42711b5242d
  const tabClickedFunc = async (e, id, parentId) => {
    // SCROLLING ADJUSTMENT3
    e.preventDefault()
    const length = getPageScrollLength(id).length
    for (let i = 0; i < length; i++) {
      smoothScrollToTarget('tabs', id, 500, 'reportsContentSection', parentId)
      await fakeDelay(700)
    }
  }
  const { isTourGuideActive } = useGlobalStore()

  return (
    <>
      <TabWrapper
        data-tabparent={removeCharFromLhsAndTabs(obj.ParentTitle)}
        id={tabId}
        className={`tab-sticky ${isFirstTab ? 'first-tab' : ''} tab-main-wrapper`}
      >
        <TabTitle>{obj.ParentTitle}</TabTitle>
        {data.map((tab, index) => {
          const id = `id_${removeCharFromLhsAndTabs(tab.Title)}_${tab.InsightsElementId.replaceAll('-', '')}`
          return (
            <TabItem
              key={index}
              onClick={(e) => tabClickedFunc(e, id, tabId)}
              href={`#${id}`}
              data-target={id}
              className='nav-link'
            >
              {tab.Title}
            </TabItem>
          )
        })}
      {isTourGuideActive && <TourGuide type="tabs" />}
      </TabWrapper>
    </>
  )
}

export default Tabs

Tabs.propTypes = {
  data: PropTypes.array,
  obj: PropTypes.object,
}
